// assets
import {
  DashboardOutlined,
  PushpinOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
} from "@ant-design/icons"

// icons
const icons = {
  DashboardOutlined,
  PushpinOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
}

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const admin = {
  id: "admin",
  // title: "Admin",
  type: "group",
  children: [
    {
      id: "users",
      title: "Users",
      type: "item",
      url: "/admin",
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
    },
    {
      id: "Providers&Departments",
      title: "Providers&Departments",
      type: "item",
      url: "/admin/Providers&Departments",
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
    },
    {
      id: "source",
      title: "Source",
      type: "item",
      url: "/admin/source",
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
    },
    {
      id: "practice",
      title: "Practices",
      type: "item",
      url: "/admin/practice",
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
    },
    // {
    //   id: "providers",
    //   title: "Providers",
    //   type: "item",
    //   url: "/admin/providers",
    //   icon: icons.UsergroupAddOutlined,
    //   breadcrumbs: false,
    // },
  ],
}

export default admin
